import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, X } from "lucide-react";

const NONE = "__none__";

export default function CategoryPicker({ value, onChange, categories, reload, canAdd = true }) {
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState("");

  const add = async () => {
    if (!name.trim()) return;
    try {
      const { data } = await api.post("/product-categories", { name });
      await reload?.();
      onChange(data.id);
      setName(""); setAdding(false);
      toast.success("Category added");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <label className="mb-1 block text-xs font-medium uppercase tracking-wider text-zinc-500">Category</label>
        {canAdd && (
          <button type="button" data-testid="new-category-toggle" onClick={() => setAdding(!adding)} className="flex items-center gap-1 text-xs font-medium text-[#e84e34] hover:underline">
            {adding ? <><X className="h-3 w-3" /> Cancel</> : <><Plus className="h-3 w-3" /> New</>}
          </button>
        )}
      </div>
      {!adding ? (
        <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? null : v)}>
          <SelectTrigger data-testid="product-category-select" className="rounded-none"><SelectValue placeholder="Category" /></SelectTrigger>
          <SelectContent>
            <SelectItem value={NONE}>No category</SelectItem>
            {categories.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
          </SelectContent>
        </Select>
      ) : (
        <div className="flex gap-2">
          <input data-testid="new-category-input" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="New category name" className="flex-1 border border-zinc-200 px-2 py-1.5 text-sm outline-none focus:border-[#e84e34]" />
          <button type="button" onClick={add} data-testid="new-category-save" className="bg-zinc-900 px-3 py-1.5 text-xs font-medium text-white hover:bg-zinc-800">Add</button>
        </div>
      )}
    </div>
  );
}
